import { MissionStateValueTO } from '@control-center/control-center-client-public-missions-ts';
import type { AdsStateFE, VehicleSubtypeFE } from 'domain/vehicle';

export type DeleteVehicleBlockReason = 'AUTONOMOUS' | 'ACTIVE_MISSION' | 'LOADING' | 'VALIDATION_ERROR';

export type DeleteVehicleEligibility =
    | { allowed: true }
    | {
          allowed: false;
          reason: DeleteVehicleBlockReason;
      };

interface GetDeleteVehicleEligibilityParams {
    subtype: VehicleSubtypeFE;
    adsState?: AdsStateFE;
    missionState?: MissionStateValueTO | null;
    isVehicleLoading?: boolean;
    isVehicleError?: boolean;
    isMissionLoading?: boolean;
    isMissionError?: boolean;
}

const BLOCKING_MISSION_STATES = new Set<MissionStateValueTO>([
    MissionStateValueTO.MissionStateValueAssigned,
    MissionStateValueTO.MissionStateValueScheduled,
]);

export const getDeleteVehicleEligibility = ({
    subtype,
    adsState,
    missionState,
    isVehicleLoading = false,
    isVehicleError = false,
    isMissionLoading = false,
    isMissionError = false,
}: GetDeleteVehicleEligibilityParams): DeleteVehicleEligibility => {
    if (subtype !== 'PHYSICAL_VEHICLE') {
        return { allowed: true };
    }

    if (adsState === 'AUTONOMOUS') {
        return { allowed: false, reason: 'AUTONOMOUS' };
    }

    if (isVehicleLoading || isMissionLoading) {
        return { allowed: false, reason: 'LOADING' };
    }

    if (isVehicleError || isMissionError) {
        return { allowed: false, reason: 'VALIDATION_ERROR' };
    }

    if (missionState && BLOCKING_MISSION_STATES.has(missionState)) {
        return { allowed: false, reason: 'ACTIVE_MISSION' };
    }

    return { allowed: true };
};
